export default "__VITE_ASSET__KnteptWG__"